<template>
    <div class="class">
        <a class="apply">学习记录</a>
        <div
            v-show="learnRecord.length === 0"
            style="position:absolute;top: 200px;left: 500px;"
        >您还没有学习过，暂无学习记录</div>
        <ul class="ul1" v-show="learnRecord.length > 0">
            <li v-for="(list,index) in learnRecord" :key="index">
                <div class="join">
                    <p>{{list.courseName}}</p>
                    <p>上课时间：{{list.beginTime}} - {{list.endTime}}</p>
                    <p>上课地点：{{list.address}}</p>
                    <p>授课教师：{{list.teacherName}}</p>
                    <p>{{list.status}}</p>
                    <el-button :style="buttonColor(list)" type="primary">{{list.checkStatusText}}</el-button>
                </div>
                <!-- float:right;position:absolute;right:100px;width:100px;height:30px;top:80px; -->
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'learnRecord',
    data() {
        return {
            learnRecord: []
        }
    },
    created() {
        this.getStudyRecord()
    },
    methods: {
        // 学习记录
        getStudyRecord() {
            this.$axios
                .get(this.$managePath + '/offline/api/course/learnRecord')
                .then(res => {
                    if (res.data.data.length === 0) {
                    } else if (res.data.status == 1) {
                        this.learnRecord = res.data.data
                    }
                })
        },
        buttonColor(list) {
            if (list.checkStatus == 2) {
                return {
                    background: '#7c7f82',
                    float: 'right',
                    position: 'absolute',
                    right: '100px',
                    width: '100px',
                    height: '30px',
                    top: '80px',
                    border: '0'
                }
            } else {
                return {
                    float: 'right',
                    position: 'absolute',
                    right: '100px',
                    width: '100px',
                    height: '30px',
                    top: '80px'
                }
            }
        }
    }
}
</script>
<style scoped>
@import '../../assets/css/iconfont.css';
@import '../../assets/css/common.css';
@import '../../assets/css/index.css';
@import '../../assets/css/cms.css';
.ul1 li {
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/mySpace/learnRecord.vue